var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticketPage"},[(_vm.isIndex)?_c('Index'):_c('div',[_c('Top'),_c('router-view',{staticClass:"ticketBox"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }